module.exports = __webpack_public_path__ + "media/react/marketing/sections/value_props/assets/purple/banner_check_icon-dbc90df84f6fcdfb8037a040d4e4f345.svg";